import game3rdApi from 'apis/game3rdApi';
import lotteryApi from 'apis/lotteryApi';
import userApi from 'apis/userApi';
import bannerDefault from 'assets/images/banner-default.jpg';
import liveArtwork01 from 'assets/images/home-provider/live-01.png';
import liveArtwork02 from 'assets/images/home-provider/live-02.png';
import liveArtwork03 from 'assets/images/home-provider/live-03.png';
import liveArtwork04 from 'assets/images/home-provider/live-04.png';
import liveArtwork05 from 'assets/images/home-provider/live-05.png';
import liveArtwork06 from 'assets/images/home-provider/live-06.png';
import liveArtwork07 from 'assets/images/home-provider/live-07.png';
import liveArtwork08 from 'assets/images/home-provider/live-08.png';
import sportArtwork01 from 'assets/images/home-provider/sport-01.png';
import sportArtwork02 from 'assets/images/home-provider/sport-02.png';
import sportArtwork03 from 'assets/images/home-provider/sport-03.png';
import sportArtwork04 from 'assets/images/home-provider/sport-04.png';
import sportArtwork05 from 'assets/images/home-provider/sport-05.png';
import sportArtwork06 from 'assets/images/home-provider/sport-06.png';
import sportArtwork07 from 'assets/images/home-provider/sport-07.png';
import sportArtwork08 from 'assets/images/home-provider/sport-08.png';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import alertMsg from 'components/alert-message/alert-message';
import GameList from 'components/home/game-list';
import LoadingIcon from 'components/loading/LoadingIcon';
import { bannerList, ltOpenDay } from 'constants/common';
import { msgAuth } from 'constants/messageAlert';
import { toggleFastLotteryHome } from 'features/configSlice';
import { LotteryMenu } from 'interfaces/lottery-menu';
import { Game3rdMenuItem, SportMatchHotModel } from 'models/commonModel';
import { LotteryGame } from 'models/lotteryListModel';
import { useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import FastLotteryHome from './lottery/FastLotteryHome';
import styles from './homepage.styles';

const fastLotteryIds = new Set([50, 100, 101, 102, 103, 104]);
const liveArtwork = [liveArtwork01, liveArtwork02, liveArtwork03, liveArtwork04, liveArtwork05, liveArtwork06, liveArtwork07, liveArtwork08];
const sportArtwork = [sportArtwork01, sportArtwork02, sportArtwork03, sportArtwork04, sportArtwork05, sportArtwork06, sportArtwork07, sportArtwork08];

function HomePage() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { menuGame } = useAppSelector((state: RootState) => state.system);
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const [loading, setLoading] = useState(false);
    const [liveCasinoList, setLiveCasinoList] = useState<Game3rdMenuItem[]>([]);
    const [sportList, setSportList] = useState<Game3rdMenuItem[]>([]);
    const [lotteryTodayList, setLotteryTodayList] = useState<LotteryGame[]>([]);
    const [matchSportList, setMatchSportList] = useState<SportMatchHotModel[]>([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [dataGameSlot, setDataGameSlot] = useState<{ title: string; product: string; category: string }>();

    useEffect(() => {
        const todayMenu = ltOpenDay[new Date().getDay()];
        const todayLottery = LotteryMenu.flatMap((group) => group.submenu).filter((item) => todayMenu.includes(item.lotteryID.toString()));
        const payload = { lotteryId: todayLottery.map((item) => item.lotteryID).filter((id) => id !== 201).join(',') };
        const loadLottery = async () => {
            try {
                const { data } = await lotteryApi.lotteryOffical4DBean(payload);
                if (data.listOfficial) {
                    setLotteryTodayList(
                        data.listOfficial.map((item: any) => ({
                            title: item.lotteryname,
                            issue: JSON.parse(item.curissue).issue,
                            opentime: item.cursitem.opentime,
                            saleend: item.cursitem.endtime,
                            nowtime: item.servertime,
                            lotteryID: item.lotteryid,
                            lotteryType: '',
                            openwin: item.cursitem?.winnumber?.split(',')[0]?.split('') || [],
                        }))
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        loadLottery();
        return () => {
            dispatch(toggleFastLotteryHome(false));
        };
    }, [dispatch]);

    useEffect(() => {
        if (!menuGame.length) return;
        const playableGame = (game: Game3rdMenuItem) => Boolean(game.providercode && game.gametype && game.ismaintain !== '1');
        setLiveCasinoList(menuGame.find((item) => item.gametype === 'LC')?.child?.filter((item) => playableGame(item) && item.providercode !== 'TX' && item.providercode !== 'XD').slice(0, 8) || []);
        setSportList(menuGame.find((item) => item.gametype === 'SB')?.child?.filter(playableGame).slice(0, 8) || []);
    }, [menuGame]);

    useEffect(() => {
        const loadSportHot = async () => {
            try {
                const { data } = await userApi.listSportView({});
                if (!data.msg) setMatchSportList(data.reslist.filter((item: SportMatchHotModel) => item.status === 1 && Date.now() - new Date(`${item.startdate} GMT+7`).getTime() < 7200000));
            } catch (error) {
                console.log(error);
            }
        };
        loadSportHot();
    }, []);

    const launchGame = async (game?: Game3rdMenuItem) => {
        if (!isLogged) return alertMsg(msgAuth.login);
        if (!game || !game.providercode || !game.gametype || game.ismaintain === '1') return toast.error('Game đang bảo trì');
        if (game.islist === '1') {
            setDataGameSlot({ category: game.category, product: game.product, title: game.name });
            return;
        }
        setLoading(true);
        try {
            const { data } = await game3rdApi.launchGame({ product: game.product, category: game.category, html5: 'WEB' } as any);
            if (!data.msg) window.open(data.url, '_blank');
            else toast.error(data.msg);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const lotteryGroups = useMemo(
        () => ({
            south: lotteryTodayList.filter((item) => fastLotteryIds.has(item.lotteryID) && item.lotteryID !== 50),
            north: lotteryTodayList.filter((item) => item.lotteryID === 50),
            today: lotteryTodayList.filter((item) => !fastLotteryIds.has(item.lotteryID)),
        }),
        [lotteryTodayList]
    );
    const featuredMatch = matchSportList[0];

    return (
        <main className={styles.homeContainer}>
            <section className={styles.bannerSlide} aria-label="Khuyến mãi nổi bật">
                <Swiper effect="fade" fadeEffect={{ crossFade: true }} autoplay={{ delay: 3500, disableOnInteraction: false }} modules={[Pagination, Autoplay, EffectFade]} speed={650} loop onSlideChange={(swiper: SwiperClass) => setActiveIndex(swiper.realIndex)}>
                    {bannerList.map((item) => <SwiperSlide key={item.id}><img className={styles.imgBanner} src={item.photourl || bannerDefault} alt="Ưu đãi VuiBet" loading="lazy" onError={(event: any) => (event.target.src = bannerDefault)} /></SwiperSlide>)}
                    <div className={styles.paginationCustom}>{bannerList.map((item, index) => <span key={item.id} className={`${styles.pagination} ${activeIndex === index ? styles.paginationFocus : ''}`} />)}</div>
                </Swiper>
            </section>

            {liveCasinoList.length > 0 && <section className={styles.casinoSection}><div className={styles.sectionContainer}>
                <SectionTitle icon="✦" title="Live Casino" />
                <div className={styles.vendorGrid}>{liveCasinoList.map((game, index) => <VendorCard key={`${game.gametype}-${game.providercode}-${game.category}`} artwork={liveArtwork[index]} label={game.name} toneIndex={index} section="casino" onClick={() => launchGame(game)} />)}</div>
            </div></section>}

            {sportList.length > 0 && <section className={styles.sportSection}><div className={styles.sectionContainer}>
                <SectionTitle icon="◉" title="Thể thao" />
                <div className={featuredMatch ? styles.sportLayout : styles.sportLayoutCompact}>
                    {featuredMatch && <article className={styles.matchFeature}><div className="match-copy"><span className="hot-label">TRẬN ĐẤU HOT</span><div className="teams"><strong>{featuredMatch.team1_name}</strong><b>VS</b><strong>{featuredMatch.team2_name}</strong></div><p>{featuredMatch.startdate}</p><button type="button" onClick={() => launchGame(sportList[0])}>CƯỢC NGAY</button></div></article>}
                    <div className={styles.sportVendorGrid}>{sportList.map((game, index) => <VendorCard key={`${game.gametype}-${game.providercode}-${game.category}`} artwork={sportArtwork[index]} label={game.name} toneIndex={index} section="sport" onClick={() => launchGame(game)} />)}</div>
                </div>
            </div></section>}

            <section className={styles.lotterySection}><div className={styles.sectionContainer}>
                <LotteryBlock title="Xổ số siêu tốc miền Nam" games={lotteryGroups.south} onViewAll={() => navigate('/lottery')} />
                <LotteryBlock title="Xổ số siêu tốc miền Bắc" games={lotteryGroups.north} onViewAll={() => navigate('/lottery')} />
                <LotteryBlock title="Xổ số hôm nay" games={lotteryGroups.today} onViewAll={() => navigate('/lottery')} />
            </div></section>
            {loading && <LoadingIcon />}
            <GameList dataGame={dataGameSlot} onClose={() => setDataGameSlot(undefined)} />
        </main>
    );
}

function SectionTitle({ icon, title }: { icon: string; title: string }) {
    return <h2 className={styles.sectionTitle}><span>{icon}</span>{title}</h2>;
}

function VendorCard({ artwork, label, onClick, toneIndex, section }: { artwork?: string; label: string; onClick: () => void; toneIndex: number; section: 'casino' | 'sport' }) {
    const artworkStyle = artwork ? { backgroundImage: `url(${artwork})` } : undefined;
    return <button type="button" data-testid="vendor-game-card" className={`${styles.vendorCard} ${section === 'sport' ? styles.sportVendorCard : ''}`} style={artworkStyle} data-tone={toneIndex % 8} onClick={onClick}><span className="vendor-label">{label}</span><span className="play">CHƠI NGAY</span></button>;
}

function LotteryBlock({ title, games, onViewAll }: { title: string; games: LotteryGame[]; onViewAll: () => void }) {
    if (!games.length) return null;
    return <div className={styles.lotteryBlock}><div className={styles.lotteryHeading}><SectionTitle icon="◉" title={title} /><button type="button" onClick={onViewAll}>XEM TẤT CẢ <span>→</span></button></div><FastLotteryHome lotteryData={games.slice(0, 4)} /></div>;
}

export default HomePage;
